import { AUTH_COOKIES, COOKIES } from '@libs/core';
import Cookies from 'js-cookie';

/** @deprecated replace with getAccessToken from libs/core/src/utils/cookies.ts */
export const getAccessToken = () => Cookies.get(AUTH_COOKIES.ACCESS_TOKEN) ?? '';

/** @deprecated replace with getAnonymousIdToken from libs/core/src/utils/cookies.ts */
export const getAnonymousIdToken = () => Cookies.get(AUTH_COOKIES.PETM_ANONYMOUS_KEY) ?? '';

/** @deprecated replace with setAnonymousIdToken from libs/core/src/utils/cookies.ts */
export const setAnonymousIdToken = (anonId: string) => Cookies.set(AUTH_COOKIES.PETM_ANONYMOUS_KEY, anonId);

/** @deprecated replace with removeCartIdToken from libs/core/src/utils/cookies.ts */
export const removeCartIdToken = () => Cookies.remove(COOKIES.CART_ID);

/** @deprecated replace with getCustomerKey from libs/core/src/utils/cookies.ts */
export const getCustomerKey = () => Cookies.get(AUTH_COOKIES.PETM_CUSTOMER_KEY) ?? '';

/** @deprecated replace with getCartIdToken from libs/core/src/utils/cookies.ts */
export const getCartIdToken = () => Cookies.get(COOKIES.CART_ID) ?? '';

/** @deprecated replace with setCartCookie from libs/core/src/utils/cookies.ts */
export const setCartCookie = (cartId: string) => {
    Cookies.set(COOKIES.CART_ID, cartId);
};

/** @deprecated replace with getVisitorId from libs/core/src/utils/cookies.ts */
export const getVisitorId = () => Cookies.get(COOKIES.X_PETM_VISITOR_ID) ?? '';

/** @deprecated replace with removeAnonymousIdToken from libs/core/src/utils/cookies.ts */
export const removeAnonymousIdToken = () => Cookies.remove(AUTH_COOKIES.PETM_ANONYMOUS_KEY);
